export var addLog = function () {
    fetch("/log/");
};
export var logError = function (err, info) {
    if (info === void 0) { info = { componentStack: '' }; }
    console.error(err);
    if (info.componentStack)
        console.error(info.componentStack);
};
